var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5007 3.5L13.0281 2.71236C12.5624 1.93617 11.4377 1.93543 10.971 2.71101L8.64207 6.58087C8.47451 6.85928 8.20122 7.05784 7.88465 7.13116L3.48163 8.15091C2.60046 8.35499 2.25326 9.42356 2.84619 10.1066L5.80891 13.5196C6.02192 13.765 6.12632 14.0863 6.09822 14.41L5.99039 15.6525M15.1688 6.2644L15.3593 6.58087C15.5269 6.85928 15.8002 7.05784 16.1167 7.13116L20.5197 8.15091C21.4009 8.35499 21.7481 9.42356 21.1552 10.1066L18.1925 13.5196C17.9794 13.765 17.8751 14.0863 17.9031 14.41L18.2939 18.9127C18.3721 19.8138 17.4631 20.4742 16.6303 20.1214L12.4688 18.3583C12.1696 18.2316 11.8318 18.2316 11.5326 18.3583L7.15146 20.2144C6.41823 20.525 5.61798 19.9436 5.68683 19.1503V19.1503L5.72477 18.713",
    stroke: "#607180",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2013cc1cd730b8875170b135ac5471d2.svg";
export { ForwardRef as ReactComponent };